import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { PurchaseOrder, User } from '@/hooks/api/models';

/**
 * 0580. 発注案件フェーズ更新
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/update_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  team_purchase_order_phase_id: number;
};
export const updatePurchaseOrderPhase = (props: Props): Promise<PurchaseOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/update_phase`, props);
};

export const useUpdatePurchaseOrderPhase = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderPhase,
  });
};
